"use client";
import { j as e } from "../../node_modules/react/jsx-runtime.js";
import { LinkWrapper as x } from "../shared/_mm_modules.js";
import { useState as p, useEffect as h } from "react";
const g = ({
  startDate: t = /* @__PURE__ */ new Date(),
  endDate: c,
  title: s,
  endMessage: o,
  hyperlinks: a,
  hasSeconds: r = !1,
  resources: n = {
    countertextdays: "dias",
    countertextseparator: ":",
    countertexthours: "horas",
    countertextminutes: "min",
    countertextseconds: "seg"
  }
}) => {
  const d = /* @__PURE__ */ new Date(), i = new Date(c), m = new Date(t);
  return /* @__PURE__ */ e.jsxs("div", { className: "countdown-holder", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "countdown-message", children: [
      /* @__PURE__ */ e.jsx("span", { className: "message-title", children: s }),
      d >= i && /* @__PURE__ */ e.jsx("span", { className: "message-sub-title", children: o })
    ] }),
    d >= m && d < i && /* @__PURE__ */ e.jsx(
      w,
      {
        endTime: i,
        hasSeconds: r,
        resources: n
      }
    ),
    a && /* @__PURE__ */ e.jsx("ul", { className: "hyperlinks", children: /* @__PURE__ */ e.jsx(x, { hyperlinks: a }) })
  ] });
}, w = ({
  endTime: t,
  hasSeconds: c,
  resources: s = {
    countertextdays: "dias",
    countertextseparator: ":",
    countertexthours: "horas",
    countertextminutes: "min",
    countertextseconds: "seg"
  }
}) => {
  const [o, a] = p(l(t));
  return h(() => {
    const r = setInterval(() => {
      const n = l(t);
      a(n), n.days === 0 && n.hours === 0 && n.minutes === 0 && n.seconds === 0 && clearInterval(r);
    }, 1e3);
    return () => clearInterval(r);
  }, [t]), /* @__PURE__ */ e.jsxs("div", { className: "box-countdown", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "countdown-group", children: [
      /* @__PURE__ */ e.jsx("span", { className: "countdown-number", suppressHydrationWarning: !0, children: u(o.days) }),
      /* @__PURE__ */ e.jsx("span", { className: "countdown-text", children: s.countertextdays })
    ] }),
    /* @__PURE__ */ e.jsx("span", { className: "countdown-split", children: s.countertextseparator }),
    /* @__PURE__ */ e.jsxs("div", { className: "countdown-group", children: [
      /* @__PURE__ */ e.jsx("span", { className: "countdown-number", suppressHydrationWarning: !0, children: u(o.hours) }),
      /* @__PURE__ */ e.jsx("span", { className: "countdown-text", children: s.countertexthours })
    ] }),
    /* @__PURE__ */ e.jsx("span", { className: "countdown-split", children: s.countertextseparator }),
    /* @__PURE__ */ e.jsxs("div", { className: "countdown-group", children: [
      /* @__PURE__ */ e.jsx("span", { className: "countdown-number", suppressHydrationWarning: !0, children: u(o.minutes) }),
      /* @__PURE__ */ e.jsx("span", { className: "countdown-text", children: s.countertextminutes })
    ] }),
    c && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("span", { className: "countdown-split", children: s.countertextseparator }),
      /* @__PURE__ */ e.jsxs("div", { className: "countdown-group", children: [
        /* @__PURE__ */ e.jsx("span", { className: "countdown-number", suppressHydrationWarning: !0, children: u(o.seconds) }),
        /* @__PURE__ */ e.jsx("span", { className: "countdown-text", children: s.countertextseconds })
      ] })
    ] })
  ] });
}, u = (t) => t.toString().padStart(2, "0"), l = (t) => {
  const c = /* @__PURE__ */ new Date(), s = t.getTime() - c.getTime();
  if (s <= 0)
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  const o = Math.floor(s / (1e3 * 60 * 60 * 24)), a = Math.floor(
    s % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
  ), r = Math.floor(s % (1e3 * 60 * 60) / (1e3 * 60)), n = Math.floor(s % (1e3 * 60) / 1e3);
  return { days: o, hours: a, minutes: r, seconds: n };
};
export {
  g as Countdown
};
